import { cls } from 'tagged-classnames-free';
export const btnCls = cls`
  bg-f-primary text-f-text h-8
  w-full rounded-lg border-none text-xs
  font-semibold disabled:!bg-[#323247]
  disabled:!text-[#707080]
`
